import * as CONSTANT from 'src/constants';
import { pushGAViewCartEvent } from 'src/helper/scripts/seoScript';

export const DISPLAY_CART_DEEP_LINK_KEY = 'displayCart';

export type ApplyViewCartIntentDeps = {
  pathname: string;
  authLoading: boolean;
  cart: {
    isOrderTypeSelected: boolean | null;
  };
  cartItems: unknown[];
  selectedStoreId?: string | number;
  verifyAddress: () => boolean;
  navigate: (path: string) => void;
  setShowCart: (show: boolean) => void;
  setOpenOrderModal: (open: boolean) => void;
  setAddressConfirmationModal: (v: {
    showModal: boolean;
    showCart: boolean;
  }) => void;
};

/**
 * Same branching as the header cart button (view cart): checkout redirect,
 * order-type modal, guest delivery confirmation, or open cart + GA.
 * Returns false only when blocked by authLoading (non-checkout).
 */
export function applyViewCartIntent(deps: ApplyViewCartIntentDeps): boolean {
  const {
    pathname,
    authLoading,
    cart,
    cartItems,
    selectedStoreId,
    verifyAddress,
    navigate,
    setShowCart,
    setOpenOrderModal,
    setAddressConfirmationModal,
  } = deps;

  if (pathname.includes(CONSTANT.ROUTE_CHECKOUT)) {
    navigate(CONSTANT.ROUTE_MENU);
    setShowCart(true);
    pushGAViewCartEvent(cartItems, selectedStoreId);
    return true;
  }

  if (authLoading) return false;

  if (!cart.isOrderTypeSelected) {
    setOpenOrderModal(true);
    return true;
  }

  if (verifyAddress()) {
    setAddressConfirmationModal({ showModal: true, showCart: true });
    return true;
  }

  setShowCart(true);
  pushGAViewCartEvent(cartItems, selectedStoreId);
  return true;
}

/** Returns new location.search (with leading ? if non-empty). */
export function stripQueryParam(search: string, paramName: string): string {
  const params = new URLSearchParams(search);
  if (!params.has(paramName)) return search;
  params.delete(paramName);
  const next = params.toString();
  return next ? `?${next}` : '';
}
